// src/routes/UserManagementRoutes.jsx
/**
 * User Management Routes
 * 
 * Nested router untuk module User Management
 * Handles all routes under /usermanagement/*
 * 
 * Routes:
 * - /usermanagement           → UserList (index)
 * - /usermanagement/create    → UserForm (create mode)
 * - /usermanagement/:id/edit  → UserForm (edit mode)
 * - /usermanagement/:id       → UserDetail (view mode) - Optional
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import toast from 'react-hot-toast';

// Components
import UserList from '../pages/usermanagement/UserList';
import UserForm from '../pages/usermanagement/UserForm';
import UserDetail from '../pages/usermanagement/UserDetail';
// import UserDetail from '../pages/usermanagement/UserDetail'; // Optional - uncomment if you create this

// Auth
import { HasPermission } from '../components/auth';
import { PERMISSIONS } from '../components/auth/constants';

const UserManagementRoutes = () => {
  return (
    <Routes>
      {/* 
        INDEX ROUTE - List Users
        Path: /usermanagement
        Permission: USER_VIEW
      */}
      <Route 
        index 
        element={
          <HasPermission permission={PERMISSIONS.USER_VIEW}>
            <UserList />
          </HasPermission>
        } 
      />

      {/* 
        CREATE ROUTE - Add New User
        Path: /usermanagement/create
        Permission: USER_CREATE
      */}
      <Route 
        path="create" 
        element={
          <HasPermission permission={PERMISSIONS.USER_CREATE}>
            <UserForm />
          </HasPermission>
        } 
      />

      {/* 
        EDIT ROUTE - Edit Existing User
        Path: /usermanagement/:id/edit
        Permission: USER_UPDATE
        
        UserForm will detect edit mode via useParams()
      */}
      <Route 
        path=":id/edit" 
        element={
          <HasPermission permission={PERMISSIONS.USER_UPDATE}>
            <UserForm />
          </HasPermission>
        } 
      />

      {/* 
        VIEW DETAIL ROUTE - View User Details (Optional)
        Path: /usermanagement/:id
        Permission: USER_VIEW
        
        Uncomment if you create UserDetail component
      */}
      
      <Route 
        path=":id" 
        element={
          <HasPermission permission={PERMISSIONS.USER_VIEW}>
            <UserDetail />
          </HasPermission>
        } 
      /> 
     
      {/* 
        FALLBACK ROUTE - Invalid paths
        Redirect to user list for any unknown routes
      */}
      <Route 
        path="*" 
        element={<Navigate to="/usermanagement" replace />} 
      />
    </Routes>
  );
};

export default UserManagementRoutes;